/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductClaimsOverview
 */
export interface ProductClaimsOverview {
    /**
     * 
     * @type {number}
     * @memberof ProductClaimsOverview
     */
    numOpen: number;
    /**
     * 
     * @type {number}
     * @memberof ProductClaimsOverview
     */
    numInProgress: number;
    /**
     * 
     * @type {number}
     * @memberof ProductClaimsOverview
     */
    numWaitingForSupplies: number;
    /**
     * 
     * @type {number}
     * @memberof ProductClaimsOverview
     */
    numRetailerActionRequired: number;
    /**
     * 
     * @type {number}
     * @memberof ProductClaimsOverview
     */
    totalSumOfClaims: number;
}

/**
 * Check if a given object implements the ProductClaimsOverview interface.
 */
export function instanceOfProductClaimsOverview(value: object): value is ProductClaimsOverview {
    if (!('numOpen' in value) || value['numOpen'] === undefined) return false;
    if (!('numInProgress' in value) || value['numInProgress'] === undefined) return false;
    if (!('numWaitingForSupplies' in value) || value['numWaitingForSupplies'] === undefined) return false;
    if (!('numRetailerActionRequired' in value) || value['numRetailerActionRequired'] === undefined) return false;
    if (!('totalSumOfClaims' in value) || value['totalSumOfClaims'] === undefined) return false;
    return true;
}

export function ProductClaimsOverviewFromJSON(json: any): ProductClaimsOverview {
    return ProductClaimsOverviewFromJSONTyped(json, false);
}

export function ProductClaimsOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductClaimsOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'numOpen': json['numOpen'],
        'numInProgress': json['numInProgress'],
        'numWaitingForSupplies': json['numWaitingForSupplies'],
        'numRetailerActionRequired': json['numRetailerActionRequired'],
        'totalSumOfClaims': json['totalSumOfClaims'],
    };
}

export function ProductClaimsOverviewToJSON(json: any): ProductClaimsOverview {
    return ProductClaimsOverviewToJSONTyped(json, false);
}

export function ProductClaimsOverviewToJSONTyped(value?: ProductClaimsOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'numOpen': value['numOpen'],
        'numInProgress': value['numInProgress'],
        'numWaitingForSupplies': value['numWaitingForSupplies'],
        'numRetailerActionRequired': value['numRetailerActionRequired'],
        'totalSumOfClaims': value['totalSumOfClaims'],
    };
}

